import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  init,
  backButton,
  mainButton,
  viewport,
  miniApp,
  hapticFeedback,
  isTMA
} from '@tma.js/sdk-react';
import { initPlatform } from '#shared/lib/platform/index.js';
import App from '#app/App.js';
import './index.css';

async function bootstrap() {
  // Initialize TMA SDK if available
  if (await isTMA()) {
    init();

    // Mount mandatory components
    backButton.mount();
    mainButton.mount();
    miniApp.mount();

    await viewport.mount().catch(console.error);
  }

  // Initialize our platform abstraction
  const platform = await initPlatform();
  await platform.initialize();

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

bootstrap().catch(console.error);
